import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { SafeTimeoutable } from "./concerns/safe_timeoutable";
import { CsrfTokenable } from "./concerns/csrf-tokenable";

export default class extends Controller {
  static targets = [ ]

  // flag de que estoy ejecutando un checkin en este momento
  checkingIn = false

  initialize(){
    Loggable(this, {debug: false})
    SafeTimeoutable(this)
    CsrfTokenable(this)
    this.log("initialized")
  }

  connect(){
    this.log("connecting")
  }

  async checkinAndRedirect(){
    if (!this.shouldCheckin()) return
    this.checkingIn = true

    try {
      const response = await this.doCheckin()
      this.data.set("checkedIn", "true")
      Turbo.visit(response.url)
    } catch (err) {
      this.log(err)
    } finally {
      this.checkingIn = false
    }
  }

  async silentCheckin(){
    if (!this.shouldCheckin()) return
    this.checkingIn = true

    try {
      await this.doCheckin()
      this.data.set("checkedIn", "true")
    } catch (err) {
      this.log(err)
    } finally {
      this.checkingIn = false
    }
  }

  async doCheckin(accept = "text/html"){
    const response = await fetch(this.data.get("checkinUrl"), {
      method: 'POST',
      headers: {
        'X-CSRF-Token': this.getCsrfToken(),
        'Accept': accept,
      },
      redirect: 'follow'
    })
    if (!response.ok) throw new Error(`Check-in failed: ${response.status}`)
    return response
  }

  checkedIn(){
    return (this.data.get("checkedIn")=="true")
  }

  userIsAuthor(){
    return (this.data.get("userIsAuthor")=="true")
  }

  shouldCheckin(event){
    return !this.checkingIn && !this.checkedIn() && !this.userIsAuthor()
  }

}
